import React, { useCallback, useEffect, useState } from "react";

import { getAllAdminUsers } from "services";

import { goTo, useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Button, Col, MainPage, Row } from "components";

export const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const signal = useCancelAsyncOnUnmount()();

  const loadAllUsers = useCallback(() => {
    getAllAdminUsers({
      signal,
    })
      .then((res) => {
        setUsers(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  const mailUser = (item) => {
    goTo(null, null, `mailto:${item.email}`, true);
  };

  useEffect(() => {
    loadAllUsers();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${users.length} admin users`}
        description="Manage admin users here. Only senior staff should have full administrative access."
        extra={
          <Button size="small" type="secondary" href="/admin-user/add">
            Add
          </Button>
        }
      />
      <Row>
        <Col>
          <AdminTable
            dataSource={users}
            config={{
              actions: [
                {
                  icon: "tabler/mail",
                  func: mailUser,
                  tooltip: "Email this user",
                },
                {
                  icon: "tabler/edit",
                  route: "/admin-user/update/",
                  tooltip: "Edit this user",
                },
              ],
              exclude: ["utc", "updated", "signedinutc", "email", "currentUser"],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
